/**
 * 计算正常和不正常值范围
 * @param {*} arr  图表数据
 * @param {Number} eventVal 告警值
 * @param {String} type 越限类型
 */
export function calcEventTime(arr, eventVal, type) {
    console.log("*******************")
    if (!(arr instanceof Array)) {
        return null
    }
    let eventTime = 0, eventItem = null

    for (let index = 0; index < arr.length; index++) {
        const element = arr[index];
        if (type == "top" && arr[index][1] > eventVal) {
            eventItem = arr[index];
        }
        else if (type == "bottom" && arr[index][1] < eventVal) {
            eventItem = arr[index];
        }
        else {
            if (eventItem) {
                //计算告警时长
                const differ = new Date(arr[index][0]).getTime() - new Date(eventItem[0]).getTime();
                eventTime += differ;
                eventItem = null
            }
        }
    }

    //计算正常和非正常结果
    const countTime = new Date(arr[arr.length - 1][0]).getTime() - new Date(arr[0][0]).getTime() + 1000*60*60;
    const normalTime = countTime - eventTime
    let obj = {
        normal: {
            time: (normalTime / 1000 / 60 / 60).toFixed(2) + "时",
            scale: ((normalTime / countTime) * 100).toFixed(2) + "%"
        },
        event: {
            time: (eventTime / 1000 / 60 / 60).toFixed(2) + "时",
            scale: ((eventTime / countTime) * 100).toFixed(2) + "%"
        }
    };
    return obj;
}